import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const glowTransition = {
  repeat: Infinity,
  repeatType: 'reverse',
  duration: 1.2,
  ease: 'easeInOut'
};

const Preloader = ({ isLoading }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-[#020617] via-[#031b0f] to-[#052e16]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
        >
          <motion.div
            className="relative flex items-center justify-center"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <motion.div
              className="absolute w-40 h-40 rounded-full bg-emerald-500/10 shadow-[0_0_50px_rgba(16,185,129,0.45)]"
              animate={{ scale: [1, 1.12, 1], opacity: [0.4, 0.7, 0.4] }}
              transition={glowTransition}
            />
            <motion.div
              className="absolute w-28 h-28 rounded-full bg-emerald-400/20"
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 9, ease: 'linear' }}
            />
            <motion.div
              className="absolute w-24 h-24 rounded-full border border-emerald-300/30"
              animate={{ rotate: -360 }}
              transition={{ repeat: Infinity, duration: 12, ease: 'linear' }}
            />
            <motion.img
              src="/new-assets/pexels-vlada-karpovich-7433824.jpg"
              alt="Blockfirst Capital"
              className="relative w-20 h-20 rounded-full object-cover border border-white/20 shadow-lg"
              animate={{ scale: [1, 1.04, 1] }}
              transition={glowTransition}
            />
          </motion.div>

          <motion.div
            className="mt-10 text-center"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
          >
            <p className="text-white/80 tracking-[0.35em] text-xs sm:text-sm uppercase">Preparing Experience</p>
            <motion.h2
              className="mt-3 text-white text-2xl sm:text-3xl font-light tracking-wide"
              animate={{ opacity: [0.6, 1, 0.6] }}
              transition={glowTransition}
            >
              Blockfirst Capital
            </motion.h2>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
